import { laptopMediumMax, mobileSmallMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

const SocialLinksContainer = styled.section`
  display: flex;
  justify-content: flex-end;
  justify-self: flex-end;

  h4 {
    color: ${(props) => props.theme.textDark};
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 18px;
  }

  @media (${laptopMediumMax}) {
    margin-top: 46px;
    flex-basis: 100%;
    justify-content: center;

    h4 {
      text-align: center;
    }
  }
`;

export const IconLink = styled.a`
  margin-bottom: 10px;
  font-size: 14px;
  display: inline-block;
  margin-right: 20px;

  &:hover img {
    filter: invert(39%) sepia(72%) saturate(4668%) hue-rotate(4deg) brightness(96%) contrast(101%);
  }

  @media screen and (${tabletMax}) {
    margin-right: 10px;
    margin-left: 10px;
  }

  @media screen and (${mobileSmallMax}) {
    margin: 0 auto 20px;
    display: block;
    text-align: center;
  }
`;

export default SocialLinksContainer;
